export default __webpack_public_path__ + "static/media/T26.85670993.png";